/**
 * Created by shinan.chen on 2021/12/25.
 */
import {getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface IClassroom{
    id:number,
    name:string,
    remark:string,
    storeId:number,
    storeName:string,
    color:string,
    enable:boolean,
}

export const listClassrooms = () =>
    getCommon({
        url: `${config.SERVICE_URL}/classroom/list_all`,
    });

export const listClassroomsByStoreId = (id:any) =>
    getCommon({
        url: `${config.SERVICE_URL}/classroom/list_by_store_id?storeId=`+id,
    });

export const listAllClassroomsByStoreId = (id:any) =>
    getCommon({
        url: `${config.SERVICE_URL}/classroom/list_all_by_store_id?storeId=`+id,
    });

export const createClassroom = (data:IClassroom) =>
    postCommon({
        url: `${config.SERVICE_URL}/classroom/create`,
        data
    });

export const updateClassroom = (data:IClassroom) =>
    postCommon({
        url: `${config.SERVICE_URL}/classroom/update`,
        data
    });

export const deleteClassroom = (id:number) =>
    postCommon({
        url: `${config.SERVICE_URL}/classroom/delete?id=${id}`
    });

export const enableClassroom = (id:number, enable:boolean) =>
    postCommon({
        url: `${config.SERVICE_URL}/classroom/enable?id=${id}&&enable=${enable}`
    });

export const pageClassrooms = (pageNum:number,pageSize:number) =>
    getCommon({
        url: `${config.SERVICE_URL}/classroom/page?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });